import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    motorRTOAll: [],
    motorRTO: {},
    currentPage: 1,
    totalPages: 1,
    rowsPerPage: 10,
    sortBy: "name",
    sortOrder: "asc",
};

const motorRTOSlice = createSlice({
    name: "motorRTO",
    initialState,
    reducers: {
        setMotorRTOAll: (state, action) => {
            state.motorRTOAll = action.payload;
        },
        setMotorRTO: (state, action) => {
            state.motorRTO = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
    },
})

export const { setMotorRTOAll, setMotorRTO, setCurrentPage, setTotalPages, setRowsPerPage } = motorRTOSlice.actions;
export default motorRTOSlice.reducer;